import axios from 'axios';
import notify from '@/store/Common/notify';
const settingsMixin = {
    data() {
        return {
            settingsLoading: true,
            settings: {},
        };
    },

    mounted() {
        // noinspection JSUnresolvedVariable
        this.getSettingData(this.settingPage);
    },

    methods: {
        getSettingData(page) {
            this.settingsLoading = true;
            axios.get(`/api/settings/page/${page}`)
                .then(response => {
                    const settings = response.data.settings;

                    settings.forEach(settingGroup => {
                        for(const [name, setting] of Object.entries(settingGroup.settingArray)) {
                            this.settings[name] = setting;
                        }
                    });
                    this.settingsLoading = false;
                });
        },

        setPostData(name, settings) {
            return {
                settings: {
                    settingName: name,
                    settingArray: settings
                }
            };
        },

        saveSettings(page, settings) {
            axios.post(`/api/settings/page/${page}`, settings)
                .then((response) => {
                    notify(response.data.message, 'success');
                });
        }
    }
};

export default settingsMixin;
